import { render, staticRenderFns } from "./QuestionAttachment.vue?vue&type=template&id=92907d40"
import script from "./QuestionAttachment.vue?vue&type=script&lang=js"
export * from "./QuestionAttachment.vue?vue&type=script&lang=js"
import style0 from "./QuestionAttachment.vue?vue&type=style&index=0&id=92907d40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports